import i18next from 'i18next'
import * as React from 'react'
import { Fun, IOWidget, any, async, fromJSX, nothing } from 'widgets-for-react'
import { ModalLayout } from '../../../../utils/modal'
import { CollectionDeleterLayout } from './collectionDeleterLayout'
import {
  CollectionDeleterState,
  collectionDeleterStateUpdaters,
} from './collectionDeleterState'

export const collectionDeleterWidget =
  (
    collectionId: string,
    componentId?: number
  ): IOWidget<
    CollectionDeleterState,
    Fun<
      CollectionDeleterState,
      CollectionDeleterState & { reloadCollections: boolean }
    >
  > =>
  (collectionDeleterState: CollectionDeleterState) =>
    any<
      Fun<
        CollectionDeleterState,
        CollectionDeleterState & { reloadCollections: boolean }
      >
    >([
      async(collectionDeleterState.deletingState).map((update) =>
        collectionDeleterStateUpdaters.deletingStateUpdater(update)
      ),
      collectionDeleterState.opened
        ? fromJSX((setState) => (
            <ModalLayout
              title={
                componentId
                  ? i18next.t('collection:modalTitleDeleteComponent')
                  : i18next.t('collection:modalTitleDeleteCollection')
              }
              onHide={() =>
                setState(collectionDeleterStateUpdaters.stopDeletingUpdater)
              }
              primaryAction={{
                kind: 'button',
                label: i18next.t('common:cancel'),
                onClick: () =>
                  setState(collectionDeleterStateUpdaters.stopDeletingUpdater),
              }}
              secondaryAction={{
                kind: 'button',
                type: 'submit',
                label: componentId
                  ? i18next.t('collection:modalButtonDeleteComponent')
                  : i18next.t('collection:modalButtonDeleteCollection'),
                isDisabled:
                  collectionDeleterState.deletingState.kind === 'loading',
                onClick: () =>
                  setState(
                    collectionDeleterStateUpdaters.startLoadingDeletingStateUpdater(
                      collectionId,
                      componentId
                    )
                  ),
              }}
            >
              {collectionDeleterState.deletingState.kind === 'unloaded' ||
              collectionDeleterState.deletingState.kind === 'loading' ? (
                <CollectionDeleterLayout.Confirmation
                  kind={componentId ? 'component' : 'collection'}
                />
              ) : (
                !(collectionDeleterState.deletingState.kind === 'loaded') && (
                  <CollectionDeleterLayout.Failed
                    kind={componentId ? 'component' : 'collection'}
                  />
                )
              )}
            </ModalLayout>
          ))
        : nothing(),
    ])
